"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./utils/constants");
var _mapScheme = require("./utils/mapScheme");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StaticMap = function StaticMap(_ref) {
  var latLng = _ref.latLng,
    scale = _ref.scale,
    scheme = _ref.scheme,
    size = _ref.size,
    zoom = _ref.zoom,
    apiKey = _ref.apiKey;
  var latitude = latLng.latitude,
    longitude = latLng.longitude;
  var apiUrl = (0, _constants.createGoogleAPIFragment)(apiKey);
  var center = "".concat(latitude, ",").concat(longitude);
  var markers = "&markers=".concat((0, _utils.getMarkerScheme)({
    center: "".concat(center),
    icon: "".concat(_constants.STATIC_MARKER_URL),
    scale: "".concat(scale)
  }));
  var mapCenter = "&center=".concat(center);
  var mapScale = "&scale=".concat(scale);
  var mapScheme = "&".concat((0, _utils.getStaticMapScheme)(scheme));
  var mapSize = "&size=".concat(size);
  var mapZoom = "&zoom=".concat(zoom);
  var mapSrc = "".concat(apiUrl).concat(mapCenter).concat(markers).concat(mapScheme).concat(mapSize).concat(mapZoom).concat(mapScale);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "map"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "map__absolute"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "map",
    className: "map__static",
    src: mapSrc
  })));
};
StaticMap.propTypes = {
  latLng: _propTypes["default"].shape({
    latitude: _propTypes["default"].number,
    longitude: _propTypes["default"].number
  }).isRequired,
  scale: _propTypes["default"].string,
  scheme: _propTypes["default"].array,
  size: _propTypes["default"].string,
  apiKey: _propTypes["default"].string.isRequired,
  zoom: _propTypes["default"].string
};
StaticMap.defaultProps = {
  scheme: _mapScheme.styles,
  // this is the existing drawer size
  size: '470x470',
  // there are certain numbers here, check Google Maps API
  zoom: '16',
  // there are certain numbers here, check Google Static Map API
  scale: '1'
};
var _default = exports["default"] = StaticMap;